
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CountryService } from 'src/app/_services/country.service';
import { GuestService } from './../../_services/guest.service';


@Component({
  selector: 'app-choose-country',
  templateUrl: './choose-country.component.html',
  styleUrls: ['./choose-country.component.css']
})
export class ChooseCountryComponent implements OnInit {
  myForm;
  iData:any=undefined
  countries:any =[]
  constructor(
    private guestService:GuestService, private countryService:CountryService
  ) { }
  get f() {
    return this.myForm.controls
  }
  ngOnInit(): void {
    this.myForm = new FormGroup({
      country: new FormControl("", [Validators.required])
    });
    this.countryService.getCountriesIdAndName().subscribe(
      x => {this.countries = x}
    )
    this.guestService.iData.subscribe(
      myIData=>{
        if(myIData){
          this.iData=myIData
        }else{
          this.guestService.getIDataDefault().subscribe(
            data=>{
              this.iData=data
            }
          )
        }
      }
    )
  }
  onCountryOptionsSelected(value: number) {
    this.guestService.getIData(value).subscribe(
      x => {
        this.iData =x
      }
    )
  }
}
